export class AppMessages {
    public static SOMETHING_WRONG = 'Something went wrong!';
    public static DOWNLOAD_SUCCESS = "File Download complete.";
 }